/*
DO NOT CHANGE any existing const in this file. They're used to
save designs. Changing these will break previous designs.
Adding new const is ok.
*/
enum DesignConfigCategories {
  ROOF = 'ROOFS',
  TRIM = 'TRIMS',
  WALL = 'WALLS',
  WINDOW = 'WINDOWS',
}

const EmptyDesignConfig = {
  [DesignConfigCategories.WALL]: {
    color: null,
    textureId: null,
  },
  [DesignConfigCategories.ROOF]: {
    textureId: null,
    color: null,
  },
  [DesignConfigCategories.TRIM]: {
    color: null,
    textureId: null,
  },
  [DesignConfigCategories.WINDOW]: {
    color: null,
    gridType: null,
    frameType: null,
  },
} as const;

export { DesignConfigCategories, EmptyDesignConfig };
